import React, { useEffect } from "react";
import TemplateLayout from "../../../../../providers/TemplateLayout";
import { useDispatch } from "react-redux";
import { setTemplateText } from "../../../../../store/slices/endorsement.slice";
import { useAppSelector } from "../../../../../hooks/app";
import { getUser } from "../../../../../store/slices/auth-slice";
import { ROLES } from "../../../../../constants";

function PreSoloOne({ templateName }: { templateName: string }) {
  const user = useAppSelector(getUser)
  const [name, setName] = React.useState(user?.role === ROLES.STUDENT ? user?.firstname + " " + user?.lastname : '')
  const [flight, setFlight] = React.useState("")
  const dispatch = useDispatch()
  useEffect(() => {
    const templateText = `I certified that ${name} has satisfactorily completed the pre-solo knowledge test of §61.87(b) for the ${flight} aircraft.`
    dispatch(setTemplateText(templateText))
  }, [name, flight, dispatch])
  return (
    <TemplateLayout templateName={templateName}>
      <div className="col-12 my-2">
        <label>Relevant FAR: (Various)</label>
      </div>

      <div className="col-12 my-2">
        <p className="certificate_text">
          I certified that <input type="text" onChange={(e) => setName(e.target.value)} value={name} /> has satisfactorily completed
          the pre-solo knowledge test of §61.87(b) for the <input type="text" onChange={(e) => setFlight(e.target.value)} /> aircraft.
        </p>
      </div>
    </TemplateLayout>
  );
}

export default PreSoloOne;
